import { defineStore } from 'pinia';

export const useSideMenuStore = defineStore('side-menu', {
  state: () => ({
    sideMenuVisible: false,
    sideMenuMode: 'fixed', // or 'overlay'
  }),
  actions: {
    toggleSideMenu() {
      this.sideMenuVisible = !this.sideMenuVisible;
    },
    openSideMenu() {
      this.sideMenuVisible = true;
    },
    closeSideMenu() {
      this.sideMenuVisible = false;
    },
    setSideMenuMode(mode) {
      this.sideMenuMode = mode;
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'side-menu',
        storage: localStorage,
        paths: ['sideMenuMode'], // Only persist the mode, not visibility
      },
    ],
  },
  getters: {
    isSideMenuVisible(state) {
      return state.sideMenuVisible;
    },
    getSideMenuMode(state) {
      return state.sideMenuMode;
    },
  },
});
